import { Button, Card, CardFooter, Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

interface PriceProps {
  priceId: string;
  name: string;
  productId: string
  locale: string,
  currency: string
  title: string;
  description: string;
  price: string;
  onClickFunction: (locale: string, priceId: string, productId: string, currency: string) => void;
}

function PriceCard({ priceId, name, productId, locale, currency, title, description, price, onClickFunction }: PriceProps) {
  const { t } = useTranslation();

  const StarSVG = () => (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5581_8881)">
        <path d="M22.396 10.8347C22.3276 10.6321 22.2034 10.4542 22.0382 10.3225C21.8731 10.1909 21.6741 10.111 21.4655 10.0928L15.3098 9.1737L12.551 3.44887C12.4624 3.26165 12.3241 3.10376 12.1519 2.99329C11.9797 2.88281 11.7806 2.82422 11.5773 2.82422C11.3741 2.82422 11.175 2.88281 11.0028 2.99329C10.8306 3.10376 10.6923 3.26165 10.6037 3.44887L7.84492 9.16263L1.68913 10.0928C1.48891 10.1219 1.30066 10.2079 1.14577 10.341C0.990875 10.4741 0.875531 10.649 0.812826 10.8458C0.755428 11.0381 0.750277 11.2427 0.797927 11.4378C0.845576 11.6329 0.944227 11.811 1.08329 11.9531L5.55138 16.3823L4.46952 22.6719C4.43089 22.8795 4.45112 23.0941 4.5278 23.2903C4.60448 23.4865 4.73441 23.6562 4.90226 23.7792C5.06586 23.8989 5.25881 23.9696 5.45947 23.9833C5.66013 23.997 5.86054 23.9532 6.03821 23.8567L11.5773 20.9002L17.0948 23.8678C17.2467 23.9555 17.4182 24.0013 17.5925 24.0007C17.8217 24.0015 18.0452 23.9279 18.2308 23.7903C18.3986 23.6672 18.5286 23.4976 18.6052 23.3014C18.6819 23.1051 18.7022 22.8906 18.6635 22.683L17.5817 16.3934L22.0498 11.9641C22.206 11.8287 22.3214 11.6507 22.3827 11.4507C22.444 11.2508 22.4486 11.0372 22.396 10.8347ZM15.7425 15.2639C15.6156 15.3896 15.5207 15.545 15.466 15.7168C15.4113 15.8886 15.3985 16.0715 15.4288 16.2495L16.2077 20.8891L12.1399 18.6745C11.9834 18.5892 11.8088 18.5446 11.6314 18.5446C11.4541 18.5446 11.2795 18.5892 11.123 18.6745L7.05516 20.8891L7.8341 16.2495C7.86433 16.0715 7.85154 15.8886 7.79685 15.7168C7.74216 15.545 7.64724 15.3896 7.52036 15.2639L4.27478 11.942L8.82942 11.2665C9.00468 11.2416 9.17128 11.173 9.31463 11.0668C9.45798 10.9606 9.57369 10.8201 9.65163 10.6575L11.5773 6.43863L13.6112 10.6686C13.6892 10.8312 13.8049 10.9717 13.9482 11.0779C14.0916 11.1841 14.2582 11.2527 14.4335 11.2776L18.9881 11.9531L15.7425 15.2639Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_5581_8881">
          <rect width="26" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )

  return (
    <>
      <Card className="w-[308px] h-[345px] 2xl:w-[358px] 2xl:h-[395px] p-[6px] flex flex-col items-center mx-auto text-#333333 border-2 border-[#FF813680] rounded-[25px]">
        <div className="w-full h-full bg-priceCardGradient rounded-[25px]">
          <div className="mt-[40px] flex mx-auto items-center justify-center px-[10px]">
            <div className=" w-[29px] h-[29px] 2xl:w-[35px] 2xl:h-[35px] bg-#FF9800 rounded-full flex justify-center items-center pb-1 pl-[2px] flex-shrink-0">
              <StarSVG />
            </div>
            <Typography variant="h2" className="text-[13px] 2xl:text-[15px] font-semibold tracking-[0.9px] 2xl:tracking-[1.4px] p-0 pl-[10px] text-center w-fit">
              {name}
            </Typography>
          </div>
          <Typography variant="h3" className="mt-[17px] 2xl:mt-[20px] uppercase text-sm 2xl:text-base font-semibold tracking-[0.9px] 2xl:tracking-[1.4px] p-0 text-center">
            {title}
          </Typography>
          <Typography variant="h3" className="mt-[20px] 2xl:mt-[35px] text-lg 2xl:text-xl font-bold tracking-[0.8px] 2xl:tracking-[1.3px] p-0 text-center">
            {price} + {t("tax")}
          </Typography>
          <Typography variant="h4" className="mt-[10px] text-[12px] font-light tracking-[0.8px] 2xl:tracking-[1.3px] p-0 px-5 text-center">
            {description}
          </Typography>
          <Typography variant="h4" className="mt-[17px] 2xl:mt-[20px] text-[12px] font-extralight italic tracking-[0.8px] 2xl:tracking-[1.3px] p-0 px-5 text-center">
            {t("PricePerSeat")}
          </Typography>
          <CardFooter className="flex absolute bottom-[10px] mx-auto w-full justify-center">
            <Button id="buyNowBtn" disabled={false} className="uppercase text-[#1E1E1E] hover:bg-[#FF7C46] bg-#FF9800 rounded-[25px] h-[40px] px-[50px] text-sm font-bold shadow-none hover:shadow-none flex justify-center items-center" onClick={() => onClickFunction(locale, productId, priceId, currency)}>
              {t("BuyNow")}
            </Button>
          </CardFooter>
        </div>
      </Card>
    </>
  );
}

export default PriceCard;
